export const giftCardScope = 'app.containers.giftCard';

export const giftCardMessages = {
  themeLavande: {
    id: `${giftCardScope}.themeLavande`,
    defaultMessage: 'Champs de lavande, Provence',
    en: 'Lavender fields, Provence',
    es: 'Campos de lavanda, Provenza',
    it: 'Campi di lavanda, Provenza',
    de: 'Lavendelfelder, Provence',
    nl: 'Lavendelvelden, Provence',
  },
  themeEtretat: {
    id: `${giftCardScope}.themeEtretat`,
    defaultMessage: 'Étretat, Normandie',
    en: 'Étretat, Normandy',
    es: 'Étretat, Normandía',
    it: 'Étretat, Normandia',
    de: 'Étretat, Normandie',
    nl: 'Étretat, Normandië',
  },
  themeChambord: {
    id: `${giftCardScope}.themeChambord`,
    defaultMessage: 'Château de Chambord',
    en: 'Château de Chambord',
    es: 'Château de Chambord',
    it: 'Château de Chambord',
    de: 'Château de Chambord',
    nl: 'Château de Chambord',
  },
  themeMontSaintMichel: {
    id: `${giftCardScope}.themeMontSaintMichel`,
    defaultMessage: 'Mont-Saint-Michel',
    en: 'Mont-Saint-Michel',
    es: 'Mont-Saint-Michel',
    it: 'Mont-Saint-Michel',
    de: 'Mont-Saint-Michel',
    nl: 'Mont-Saint-Michel',
  },
  themeEsterel: {
    id: `${giftCardScope}.themeEsterel`,
    defaultMessage: "Esterel, Côte d'Azur",
    en: 'Esterel, French Riviera',
    es: 'Esterel, Costa Azul',
    it: 'Esterel, Costa Azzurra',
    de: "Esterel, Côte d'Azur",
    nl: "Esterel, Côte d'Azur",
  },
  themeColmar: {
    id: `${giftCardScope}.themeColmar`,
    defaultMessage: 'Colmar, Alsace',
    en: 'Colmar, Alsace',
    es: 'Colmar, Alsacia',
    it: 'Colmar, Alsazia',
    de: 'Colmar, Elsass',
    nl: 'Colmar, Elzas',
  },
  themeVerdon: {
    id: `${giftCardScope}.themeVerdon`,
    defaultMessage: 'Gorges du Verdon',
    en: 'Verdon Gorge',
    es: 'Garganta del Verdon',
    it: 'Gole del Verdon',
    de: 'Verdonschlucht',
    nl: 'Verdonkloof',
  },
  themeParis: {
    id: `${giftCardScope}.themeParis`,
    defaultMessage: 'Paris, tour Eiffel',
    en: 'Paris, Eiffel Tower',
    es: 'París, torre Eiffel',
    it: 'Parigi, torre Eiffel',
    de: 'Paris, Eiffelturm',
    nl: 'Parijs, Eiffeltoren',
  },
  themeAmsterdam: {
    id: `${giftCardScope}.themeAmsterdam`,
    defaultMessage: 'Amsterdam, Damrak',
    en: 'Amsterdam, Damrak',
    es: 'Amsterdam, Damrak',
    it: 'Amsterdam, Damrak',
    de: 'Amsterdam, Damrak',
    nl: 'Amsterdam, Damrak',
  },
  themeKinderdijk: {
    id: `${giftCardScope}.themeKinderdijk`,
    defaultMessage: 'Moulins de Kinderdijk',
    en: 'Kinderdijk windmills',
    es: 'Molinos de Kinderdijk',
    it: 'Mulini di Kinderdijk',
    de: 'Windmühlen von Kinderdijk',
    nl: 'Molens van Kinderdijk',
  },
  themeBigBen: {
    id: `${giftCardScope}.themeBigBen`,
    defaultMessage: 'Londres, Big Ben',
    en: 'London, Big Ben',
    es: 'Londres, Big Ben',
    it: 'Londra, Big Ben',
    de: 'London, Big Ben',
    nl: 'Londen, Big Ben',
  },
  themeTowerBridge: {
    id: `${giftCardScope}.themeTowerBridge`,
    defaultMessage: 'Londres, Tower Bridge',
    en: 'London, Tower Bridge',
    es: 'Londres, Tower Bridge',
    it: 'Londra, Tower Bridge',
    de: 'London, Tower Bridge',
    nl: 'Londen, Tower Bridge',
  },
  cardLabel: {
    id: `${giftCardScope}.cardLabel`,
    defaultMessage: 'Carte cadeau',
    en: 'Gift card',
    es: 'Tarjeta regalo',
    it: 'Carta regalo',
    de: 'Geschenkkarte',
    nl: 'Cadeaukaart',
  },
  metaTitle: {
    id: `${giftCardScope}.metaTitle`,
    defaultMessage:
      'Carte cadeau Tictactrip : offrez un voyage en train ou en bus',
    en: 'Tictactrip gift card: give a train or bus trip',
    es: 'Tarjeta regalo Tictactrip: regala un viaje en tren o autobús',
    it: 'Carta regalo Tictactrip: regala un viaggio in treno o in autobus',
    de: 'Tictactrip Geschenkkarte: Verschenken Sie eine Zug- oder Busreise',
    nl: 'Tictactrip cadeaukaart: geef een trein- of busreis cadeau',
  },
  metaDescription: {
    id: `${giftCardScope}.metaDescription`,
    defaultMessage:
      'Offrez une carte cadeau Tictactrip : montant libre, valable 1 an sur tous les trajets en train et en bus, utilisable en plusieurs fois.',
    en: 'Give a Tictactrip gift card: any amount, valid for 1 year on every train and bus trip, usable several times.',
    es: 'Regala una tarjeta regalo Tictactrip: importe libre, válida 1 año en todos los viajes en tren y autobús, utilizable varias veces.',
    it: 'Regala una carta regalo Tictactrip: importo libero, valida 1 anno su tutti i viaggi in treno e autobus, utilizzabile più volte.',
    de: 'Verschenken Sie eine Tictactrip Geschenkkarte: freier Betrag, 1 Jahr gültig für alle Zug- und Busreisen, mehrfach nutzbar.',
    nl: 'Geef een Tictactrip cadeaukaart: vrij bedrag, 1 jaar geldig op alle trein- en busreizen, meerdere keren te gebruiken.',
  },
  heroEyebrow: {
    id: `${giftCardScope}.heroEyebrow`,
    defaultMessage: 'Carte cadeau Tictactrip',
    en: 'Tictactrip gift card',
    es: 'Tarjeta regalo Tictactrip',
    it: 'Carta regalo Tictactrip',
    de: 'Tictactrip Geschenkkarte',
    nl: 'Tictactrip cadeaukaart',
  },
  heroTitle: {
    id: `${giftCardScope}.heroTitle`,
    defaultMessage: 'Offrez un voyage. Ils choisissent la destination.',
    en: 'Give a trip. They choose where to go.',
    es: 'Regala un viaje. Ellos eligen el destino.',
    it: 'Regala un viaggio. Loro scelgono la meta.',
    de: 'Schenken Sie eine Reise. Sie wählen das Ziel.',
    nl: 'Geef een reis cadeau. Zij kiezen de bestemming.',
  },
  heroText: {
    id: `${giftCardScope}.heroText`,
    defaultMessage:
      'En train ou en bus, en France et en Europe. Une carte valable 1 an sur tous les trajets Tictactrip, utilisable en plusieurs fois.',
    en: 'By train or bus, in France and Europe. A card valid for 1 year on every Tictactrip trip, usable several times.',
    es: 'En tren o autobús, en Francia y en Europa. Una tarjeta válida 1 año en todos los viajes de Tictactrip, utilizable varias veces.',
    it: 'In treno o in autobus, in Francia e in Europa. Una carta valida 1 anno su tutti i viaggi Tictactrip, utilizzabile più volte.',
    de: 'Mit Zug oder Bus, in Frankreich und Europa. Eine Karte, 1 Jahr gültig für alle Tictactrip-Reisen, mehrfach nutzbar.',
    nl: 'Met de trein of bus, in Frankrijk en Europa. Een kaart die 1 jaar geldig is op alle Tictactrip-reizen, meerdere keren te gebruiken.',
  },
  ctaOffer: {
    id: `${giftCardScope}.ctaOffer`,
    defaultMessage: 'Offrir une carte cadeau',
    en: 'Give a gift card',
    es: 'Regalar una tarjeta regalo',
    it: 'Regala una carta regalo',
    de: 'Geschenkkarte verschenken',
    nl: 'Cadeaukaart geven',
  },
  ctaHave: {
    id: `${giftCardScope}.ctaHave`,
    defaultMessage: "J'ai une carte cadeau",
    en: 'I have a gift card',
    es: 'Tengo una tarjeta regalo',
    it: 'Ho una carta regalo',
    de: 'Ich habe eine Geschenkkarte',
    nl: 'Ik heb een cadeaukaart',
  },
  checkFreeAmount: {
    id: `${giftCardScope}.checkFreeAmount`,
    defaultMessage: 'Montant libre dès 10 €',
    en: 'Any amount from €10',
    es: 'Importe libre desde 10 €',
    it: 'Importo libero da 10 €',
    de: 'Freier Betrag ab 10 €',
    nl: 'Vrij bedrag vanaf € 10',
  },
  checkSchedule: {
    id: `${giftCardScope}.checkSchedule`,
    defaultMessage: 'Envoyée tout de suite ou le jour J',
    en: 'Sent now or on the big day',
    es: 'Enviada ya o el día elegido',
    it: 'Inviata subito o nel giorno scelto',
    de: 'Sofort oder am großen Tag verschickt',
    nl: 'Meteen of op de grote dag verstuurd',
  },
  checkSeveralTimes: {
    id: `${giftCardScope}.checkSeveralTimes`,
    defaultMessage: 'Utilisable en plusieurs fois',
    en: 'Usable several times',
    es: 'Utilizable varias veces',
    it: 'Utilizzabile più volte',
    de: 'Mehrfach nutzbar',
    nl: 'Meerdere keren te gebruiken',
  },
  checkValidity: {
    id: `${giftCardScope}.checkValidity`,
    defaultMessage: 'Valable 1 an',
    en: 'Valid for 1 year',
    es: 'Válida 1 año',
    it: 'Valida 1 anno',
    de: '1 Jahr gültig',
    nl: '1 jaar geldig',
  },
  argChooseTitle: {
    id: `${giftCardScope}.argChooseTitle`,
    defaultMessage: 'Ils choisissent tout',
    en: 'They choose everything',
    es: 'Ellos lo eligen todo',
    it: 'Scelgono tutto loro',
    de: 'Sie wählen alles',
    nl: 'Zij kiezen alles',
  },
  argChooseText: {
    id: `${giftCardScope}.argChooseText`,
    defaultMessage:
      'Destination, date, compagnie : la carte paie tous les trajets en train et en bus vendus sur Tictactrip.',
    en: 'Destination, date, company: the card pays for every train and bus trip sold on Tictactrip.',
    es: 'Destino, fecha, compañía: la tarjeta paga todos los viajes en tren y autobús vendidos en Tictactrip.',
    it: 'Destinazione, data, compagnia: la carta paga tutti i viaggi in treno e in autobus venduti su Tictactrip.',
    de: 'Ziel, Datum, Anbieter: Die Karte bezahlt alle auf Tictactrip verkauften Zug- und Busreisen.',
    nl: 'Bestemming, datum, maatschappij: de kaart betaalt alle trein- en busreizen die op Tictactrip worden verkocht.',
  },
  argPersonalTitle: {
    id: `${giftCardScope}.argPersonalTitle`,
    defaultMessage: 'Un cadeau qui vous ressemble',
    en: 'A gift that looks like you',
    es: 'Un regalo a tu imagen',
    it: 'Un regalo che ti somiglia',
    de: 'Ein Geschenk, das zu Ihnen passt',
    nl: 'Een cadeau dat bij u past',
  },
  argPersonalText: {
    id: `${giftCardScope}.argPersonalText`,
    defaultMessage:
      "Un thème, votre message, et l'envoi programmé le jour et à l'heure de votre choix.",
    en: 'A theme, your message, and the email sent on the day and at the time you choose.',
    es: 'Un tema, tu mensaje y el envío programado el día y a la hora que elijas.',
    it: "Un tema, il tuo messaggio e l'invio programmato nel giorno e all'ora che preferisci.",
    de: 'Ein Motiv, Ihre Nachricht und der Versand an dem Tag und zu der Uhrzeit Ihrer Wahl.',
    nl: 'Een thema, uw bericht en verzending op de dag en het tijdstip van uw keuze.',
  },
  argGreenTitle: {
    id: `${giftCardScope}.argGreenTitle`,
    defaultMessage: 'Un cadeau plus vert',
    en: 'A greener gift',
    es: 'Un regalo más verde',
    it: 'Un regalo più verde',
    de: 'Ein grüneres Geschenk',
    nl: 'Een groener cadeau',
  },
  argGreenText: {
    id: `${giftCardScope}.argGreenText`,
    defaultMessage:
      "Le train et le car émettent bien moins de CO₂ que la voiture seule ou l'avion.",
    en: 'Trains and coaches emit far less CO₂ than driving alone or flying.',
    es: 'El tren y el autobús emiten mucho menos CO₂ que el coche en solitario o el avión.',
    it: "Treno e autobus emettono molta meno CO₂ dell'auto da soli o dell'aereo.",
    de: 'Zug und Bus stoßen viel weniger CO₂ aus als das Auto allein oder das Flugzeug.',
    nl: 'Trein en bus stoten veel minder CO₂ uit dan alleen autorijden of vliegen.',
  },
  themesTitle: {
    id: `${giftCardScope}.themesTitle`,
    defaultMessage: 'Un thème pour chaque envie',
    en: 'A theme for every wish',
    es: 'Un tema para cada deseo',
    it: 'Un tema per ogni desiderio',
    de: 'Ein Motiv für jeden Wunsch',
    nl: 'Een thema voor elke wens',
  },
  themesText: {
    id: `${giftCardScope}.themesText`,
    defaultMessage:
      'Le thème habille la carte. Elle reste valable sur tous les trajets.',
    en: 'The theme dresses the card. It stays valid on every trip.',
    es: 'El tema decora la tarjeta. Sigue siendo válida en todos los viajes.',
    it: 'Il tema decora la carta. Resta valida su tutti i viaggi.',
    de: 'Das Motiv schmückt die Karte. Sie gilt weiterhin für alle Reisen.',
    nl: 'Het thema siert de kaart. Ze blijft geldig op alle reizen.',
  },
  offerTheme: {
    id: `${giftCardScope}.offerTheme`,
    defaultMessage: 'Offrir « {theme} »',
    en: 'Give “{theme}”',
    es: 'Regalar «{theme}»',
    it: 'Regala «{theme}»',
    de: '„{theme}“ verschenken',
    nl: '„{theme}” geven',
  },
  formatsTitle: {
    id: `${giftCardScope}.formatsTitle`,
    defaultMessage: 'Deux formats au choix',
    en: 'Two formats to choose from',
    es: 'Dos formatos a elegir',
    it: 'Due formati a scelta',
    de: 'Zwei Formate zur Auswahl',
    nl: 'Twee formaten naar keuze',
  },
  ecardTitle: {
    id: `${giftCardScope}.ecardTitle`,
    defaultMessage: 'E-carte cadeau',
    en: 'E-gift card',
    es: 'Tarjeta regalo electrónica',
    it: 'Carta regalo digitale',
    de: 'E-Geschenkkarte',
    nl: 'E-cadeaukaart',
  },
  ecardText: {
    id: `${giftCardScope}.ecardText`,
    defaultMessage:
      "Envoyée au destinataire par email, tout de suite ou le jour et à l'heure de votre choix.",
    en: 'Emailed to the recipient, now or on the day and at the time you choose.',
    es: 'Enviada por email al destinatario, ya o el día y a la hora que elijas.',
    it: "Inviata via email al destinatario, subito o nel giorno e all'ora che preferisci.",
    de: 'Per E-Mail an die beschenkte Person, sofort oder an dem Tag und zu der Uhrzeit Ihrer Wahl.',
    nl: 'Per e-mail naar de ontvanger, meteen of op de dag en het tijdstip van uw keuze.',
  },
  printTitle: {
    id: `${giftCardScope}.printTitle`,
    defaultMessage: 'Carte à imprimer',
    en: 'Card to print',
    es: 'Tarjeta para imprimir',
    it: 'Carta da stampare',
    de: 'Karte zum Ausdrucken',
    nl: 'Kaart om te printen',
  },
  printText: {
    id: `${giftCardScope}.printText`,
    defaultMessage:
      "Envoyée dans votre boîte mail dès le paiement. Vous l'imprimez et l'offrez en main propre.",
    en: 'Sent to your inbox once paid. Print it and hand it over yourself.',
    es: 'Enviada a tu correo tras el pago. La imprimes y la entregas en mano.',
    it: 'Inviata nella tua casella email dopo il pagamento. La stampi e la consegni di persona.',
    de: 'Nach der Zahlung in Ihr Postfach geschickt. Drucken Sie sie aus und überreichen Sie sie persönlich.',
    nl: 'Na betaling naar uw mailbox gestuurd. Print hem en geef hem persoonlijk.',
  },
  fromAmount: {
    id: `${giftCardScope}.fromAmount`,
    defaultMessage: 'Montant au choix, dès 10 €',
    en: 'Any amount, from €10',
    es: 'Importe a elegir, desde 10 €',
    it: 'Importo a scelta, da 10 €',
    de: 'Betrag nach Wahl, ab 10 €',
    nl: 'Bedrag naar keuze, vanaf € 10',
  },
  howTitle: {
    id: `${giftCardScope}.howTitle`,
    defaultMessage: 'Comment ça marche',
    en: 'How it works',
    es: 'Cómo funciona',
    it: 'Come funziona',
    de: 'So funktioniert es',
    nl: 'Hoe het werkt',
  },
  how1Title: {
    id: `${giftCardScope}.how1Title`,
    defaultMessage: 'Composez la carte',
    en: 'Make the card',
    es: 'Crea la tarjeta',
    it: 'Crea la carta',
    de: 'Gestalten Sie die Karte',
    nl: 'Stel de kaart samen',
  },
  how1Text: {
    id: `${giftCardScope}.how1Text`,
    defaultMessage:
      "Thème, montant, message et date d'envoi. L'aperçu se met à jour en direct.",
    en: 'Theme, amount, message and sending date. The preview updates live.',
    es: 'Tema, importe, mensaje y fecha de envío. La vista previa se actualiza al momento.',
    it: "Tema, importo, messaggio e data di invio. L'anteprima si aggiorna in tempo reale.",
    de: 'Motiv, Betrag, Nachricht und Versanddatum. Die Vorschau aktualisiert sich sofort.',
    nl: 'Thema, bedrag, bericht en verzenddatum. Het voorbeeld wordt direct bijgewerkt.',
  },
  how2Title: {
    id: `${giftCardScope}.how2Title`,
    defaultMessage: 'Payez en ligne',
    en: 'Pay online',
    es: 'Paga en línea',
    it: 'Paga online',
    de: 'Online bezahlen',
    nl: 'Betaal online',
  },
  how2Text: {
    id: `${giftCardScope}.how2Text`,
    defaultMessage:
      'Paiement sécurisé par carte bancaire. Vous recevez votre reçu par email.',
    en: 'Secure card payment. You get your receipt by email.',
    es: 'Pago seguro con tarjeta. Recibes tu recibo por email.',
    it: 'Pagamento sicuro con carta. Ricevi la ricevuta via email.',
    de: 'Sichere Kartenzahlung. Sie erhalten Ihre Quittung per E-Mail.',
    nl: 'Veilige betaling met kaart. U ontvangt uw bewijs per e-mail.',
  },
  how3Title: {
    id: `${giftCardScope}.how3Title`,
    defaultMessage: 'Ils réservent avec le code',
    en: 'They book with the code',
    es: 'Reservan con el código',
    it: 'Prenotano con il codice',
    de: 'Sie buchen mit dem Code',
    nl: 'Zij boeken met de code',
  },
  how3Text: {
    id: `${giftCardScope}.how3Text`,
    defaultMessage:
      'Ils choisissent leur trajet et saisissent le code au paiement. Le solde reste sur la carte.',
    en: 'They choose their trip and type the code when paying. The balance stays on the card.',
    es: 'Eligen su viaje e introducen el código al pagar. El saldo se queda en la tarjeta.',
    it: 'Scelgono il viaggio e inseriscono il codice al pagamento. Il saldo resta sulla carta.',
    de: 'Sie wählen ihre Reise und geben den Code beim Bezahlen ein. Das Guthaben bleibt auf der Karte.',
    nl: 'Zij kiezen hun reis en vullen de code in bij het betalen. Het saldo blijft op de kaart.',
  },
  redeemBlockTitle: {
    id: `${giftCardScope}.redeemBlockTitle`,
    defaultMessage: 'Vous avez reçu une carte cadeau ?',
    en: 'Did you get a gift card?',
    es: '¿Has recibido una tarjeta regalo?',
    it: 'Hai ricevuto una carta regalo?',
    de: 'Haben Sie eine Geschenkkarte erhalten?',
    nl: 'Heeft u een cadeaukaart gekregen?',
  },
  redeemBlockText: {
    id: `${giftCardScope}.redeemBlockText`,
    defaultMessage: 'Vérifiez votre solde, puis choisissez votre trajet.',
    en: 'Check your balance, then choose your trip.',
    es: 'Consulta tu saldo y elige tu viaje.',
    it: 'Controlla il saldo, poi scegli il viaggio.',
    de: 'Prüfen Sie Ihr Guthaben und wählen Sie dann Ihre Reise.',
    nl: 'Bekijk uw saldo en kies dan uw reis.',
  },
  codeLabel: {
    id: `${giftCardScope}.codeLabel`,
    defaultMessage: 'Code de la carte',
    en: 'Card code',
    es: 'Código de la tarjeta',
    it: 'Codice della carta',
    de: 'Code der Karte',
    nl: 'Code van de kaart',
  },
  useCard: {
    id: `${giftCardScope}.useCard`,
    defaultMessage: 'Utiliser ma carte',
    en: 'Use my card',
    es: 'Usar mi tarjeta',
    it: 'Usa la mia carta',
    de: 'Meine Karte verwenden',
    nl: 'Mijn kaart gebruiken',
  },
  faqTitle: {
    id: `${giftCardScope}.faqTitle`,
    defaultMessage: 'Questions fréquentes',
    en: 'Frequently asked questions',
    es: 'Preguntas frecuentes',
    it: 'Domande frequenti',
    de: 'Häufige Fragen',
    nl: 'Veelgestelde vragen',
  },
  faq1Q: {
    id: `${giftCardScope}.faq1Q`,
    defaultMessage: 'Combien de temps la carte est-elle valable ?',
    en: 'How long is the card valid?',
    es: '¿Cuánto tiempo es válida la tarjeta?',
    it: 'Per quanto tempo è valida la carta?',
    de: 'Wie lange ist die Karte gültig?',
    nl: 'Hoe lang is de kaart geldig?',
  },
  faq1A: {
    id: `${giftCardScope}.faq1A`,
    defaultMessage:
      "1 an à partir de l'achat. La date de fin est écrite dans l'email de la carte.",
    en: '1 year from purchase. The end date is written in the card email.',
    es: '1 año desde la compra. La fecha de fin figura en el email de la tarjeta.',
    it: "1 anno dall'acquisto. La data di scadenza è indicata nell'email della carta.",
    de: '1 Jahr ab Kauf. Das Enddatum steht in der E-Mail der Karte.',
    nl: '1 jaar vanaf aankoop. De einddatum staat in de e-mail van de kaart.',
  },
  faq2Q: {
    id: `${giftCardScope}.faq2Q`,
    defaultMessage: "Peut-on l'utiliser en plusieurs fois ?",
    en: 'Can it be used several times?',
    es: '¿Se puede usar varias veces?',
    it: 'Si può usare più volte?',
    de: 'Kann man sie mehrmals verwenden?',
    nl: 'Kan hij meerdere keren gebruikt worden?',
  },
  faq2A: {
    id: `${giftCardScope}.faq2A`,
    defaultMessage:
      "Oui. Le montant non utilisé reste sur la carte jusqu'à sa date de fin.",
    en: 'Yes. What is not spent stays on the card until its end date.',
    es: 'Sí. El importe no usado se queda en la tarjeta hasta su fecha de fin.',
    it: "Sì. L'importo non usato resta sulla carta fino alla scadenza.",
    de: 'Ja. Der nicht genutzte Betrag bleibt bis zum Enddatum auf der Karte.',
    nl: 'Ja. Het niet gebruikte bedrag blijft tot de einddatum op de kaart.',
  },
  faq3Q: {
    id: `${giftCardScope}.faq3Q`,
    defaultMessage: 'Que peut-on payer avec ?',
    en: 'What can it pay for?',
    es: '¿Qué se puede pagar con ella?',
    it: 'Cosa si può pagare?',
    de: 'Was kann man damit bezahlen?',
    nl: 'Wat kun je ermee betalen?',
  },
  faq3A: {
    id: `${giftCardScope}.faq3A`,
    defaultMessage:
      'Tout : les billets de train et de bus vendus sur Tictactrip, les frais de service et les options.',
    en: 'Everything: train and bus tickets sold on Tictactrip, service fees and options.',
    es: 'Todo: los billetes de tren y autobús vendidos en Tictactrip, los gastos de gestión y las opciones.',
    it: 'Tutto: i biglietti di treno e autobus venduti su Tictactrip, le commissioni e le opzioni.',
    de: 'Alles: auf Tictactrip verkaufte Zug- und Bustickets, Servicegebühren und Optionen.',
    nl: 'Alles: trein- en buskaartjes die op Tictactrip worden verkocht, servicekosten en opties.',
  },
  faq4Q: {
    id: `${giftCardScope}.faq4Q`,
    defaultMessage: 'Peut-on cumuler plusieurs cartes ?',
    en: 'Can several cards be combined?',
    es: '¿Se pueden combinar varias tarjetas?',
    it: 'Si possono combinare più carte?',
    de: 'Kann man mehrere Karten kombinieren?',
    nl: 'Kun je meerdere kaarten combineren?',
  },
  faq4A: {
    id: `${giftCardScope}.faq4A`,
    defaultMessage:
      'Oui : plusieurs cartes cadeaux sur une même commande, et un code promo en plus.',
    en: 'Yes: several gift cards on one order, plus one promo code.',
    es: 'Sí: varias tarjetas regalo en un mismo pedido, y un código promocional además.',
    it: 'Sì: più carte regalo sullo stesso ordine, più un codice promozionale.',
    de: 'Ja: mehrere Geschenkkarten in einer Bestellung, dazu ein Gutscheincode.',
    nl: 'Ja: meerdere cadeaukaarten op één bestelling, plus een promotiecode.',
  },
  faq5Q: {
    id: `${giftCardScope}.faq5Q`,
    defaultMessage: 'La carte est-elle remboursable ?',
    en: 'Is the card refundable?',
    es: '¿La tarjeta es reembolsable?',
    it: 'La carta è rimborsabile?',
    de: 'Ist die Karte erstattungsfähig?',
    nl: 'Is de kaart terugbetaalbaar?',
  },
  faq5A: {
    id: `${giftCardScope}.faq5A`,
    defaultMessage:
      "Non. Si un billet payé avec la carte est annulé et remboursé, 50 % de la part payée par la carte revient sur la carte, hors frais de modification ou d'annulation.",
    en: 'No. If a ticket paid with the card is cancelled and refunded, 50% of the part paid by the card goes back on the card, change or cancellation fees excluded.',
    es: 'No. Si se anula y reembolsa un billete pagado con la tarjeta, el 50 % de la parte pagada con la tarjeta vuelve a la tarjeta, sin contar los gastos de cambio o anulación.',
    it: 'No. Se un biglietto pagato con la carta viene annullato e rimborsato, il 50% della parte pagata con la carta torna sulla carta, escluse le spese di modifica o annullamento.',
    de: 'Nein. Wird ein mit der Karte bezahltes Ticket storniert und erstattet, gehen 50 % des mit der Karte bezahlten Anteils zurück auf die Karte, ohne Änderungs- oder Stornogebühren.',
    nl: 'Nee. Als een met de kaart betaald ticket wordt geannuleerd en terugbetaald, gaat 50% van het met de kaart betaalde deel terug naar de kaart, exclusief wijzigings- of annuleringskosten.',
  },
  faq6Q: {
    id: `${giftCardScope}.faq6Q`,
    defaultMessage: "Puis-je choisir le jour de l'envoi ?",
    en: 'Can I choose when it is sent?',
    es: '¿Puedo elegir el día de envío?',
    it: "Posso scegliere il giorno dell'invio?",
    de: 'Kann ich den Versandtag wählen?',
    nl: 'Kan ik de verzenddag kiezen?',
  },
  faq6A: {
    id: `${giftCardScope}.faq6A`,
    defaultMessage:
      "Oui, pour une e-carte : le jour et l'heure, jusqu'à un an à l'avance.",
    en: 'Yes, for an e-card: the day and time, up to one year ahead.',
    es: 'Sí, para una tarjeta electrónica: el día y la hora, hasta con un año de antelación.',
    it: 'Sì, per una carta digitale: giorno e ora, fino a un anno prima.',
    de: 'Ja, bei einer E-Karte: Tag und Uhrzeit, bis zu einem Jahr im Voraus.',
    nl: 'Ja, voor een e-kaart: de dag en het tijdstip, tot een jaar vooruit.',
  },
  createTitle: {
    id: `${giftCardScope}.createTitle`,
    defaultMessage: 'Offrir une carte cadeau',
    en: 'Give a gift card',
    es: 'Regalar una tarjeta regalo',
    it: 'Regala una carta regalo',
    de: 'Geschenkkarte verschenken',
    nl: 'Cadeaukaart geven',
  },
  themeHint: {
    id: `${giftCardScope}.themeHint`,
    defaultMessage:
      "Le thème n'est qu'une illustration : la carte s'utilise sur tous les trajets en train et en bus, partout.",
    en: 'The theme is only a picture: the card works on every train and bus trip, anywhere.',
    es: 'El tema es solo una ilustración: la tarjeta sirve para todos los trayectos en tren y autobús, a cualquier destino.',
    it: 'Il tema è solo un’illustrazione: la carta vale per tutti i viaggi in treno e in autobus, ovunque.',
    de: 'Das Motiv ist nur eine Illustration: Die Karte gilt für alle Zug- und Busreisen, überallhin.',
    nl: 'Het thema is alleen een illustratie: de kaart geldt voor alle trein- en busreizen, overal naartoe.',
  },
  step1: {
    id: `${giftCardScope}.step1`,
    defaultMessage: '1. Choisissez un thème',
    en: '1. Choose a theme',
    es: '1. Elige un tema',
    it: '1. Scegli un tema',
    de: '1. Wählen Sie ein Motiv',
    nl: '1. Kies een thema',
  },
  step2: {
    id: `${giftCardScope}.step2`,
    defaultMessage: '2. Choisissez le format',
    en: '2. Choose the format',
    es: '2. Elige el formato',
    it: '2. Scegli il formato',
    de: '2. Wählen Sie das Format',
    nl: '2. Kies het formaat',
  },
  step3: {
    id: `${giftCardScope}.step3`,
    defaultMessage: '3. Choisissez un montant',
    en: '3. Choose an amount',
    es: '3. Elige un importe',
    it: '3. Scegli un importo',
    de: '3. Wählen Sie einen Betrag',
    nl: '3. Kies een bedrag',
  },
  step4: {
    id: `${giftCardScope}.step4`,
    defaultMessage: '4. Personnalisez la carte',
    en: '4. Personalise the card',
    es: '4. Personaliza la tarjeta',
    it: '4. Personalizza la carta',
    de: '4. Personalisieren Sie die Karte',
    nl: '4. Personaliseer de kaart',
  },
  step5Ecard: {
    id: `${giftCardScope}.step5Ecard`,
    defaultMessage: '5. Envoyez la carte',
    en: '5. Send the card',
    es: '5. Envía la tarjeta',
    it: '5. Invia la carta',
    de: '5. Senden Sie die Karte',
    nl: '5. Verstuur de kaart',
  },
  step5Print: {
    id: `${giftCardScope}.step5Print`,
    defaultMessage: '5. Recevez la carte',
    en: '5. Get the card',
    es: '5. Recibe la tarjeta',
    it: '5. Ricevi la carta',
    de: '5. Erhalten Sie die Karte',
    nl: '5. Ontvang de kaart',
  },
  customAmount: {
    id: `${giftCardScope}.customAmount`,
    defaultMessage: 'Ou un montant libre (de 10 à 500 €)',
    en: 'Or any amount (€10 to €500)',
    es: 'O un importe libre (de 10 a 500 €)',
    it: 'O un importo libero (da 10 a 500 €)',
    de: 'Oder ein freier Betrag (10 bis 500 €)',
    nl: 'Of een vrij bedrag (€ 10 tot € 500)',
  },
  amountError: {
    id: `${giftCardScope}.amountError`,
    defaultMessage: 'Le montant doit être compris entre 10 et 500 €.',
    en: 'The amount must be between €10 and €500.',
    es: 'El importe debe estar entre 10 y 500 €.',
    it: "L'importo deve essere tra 10 e 500 €.",
    de: 'Der Betrag muss zwischen 10 und 500 € liegen.',
    nl: 'Het bedrag moet tussen € 10 en € 500 liggen.',
  },
  fromLabel: {
    id: `${giftCardScope}.fromLabel`,
    defaultMessage: 'De la part de',
    en: 'From',
    es: 'De parte de',
    it: 'Da parte di',
    de: 'Von',
    nl: 'Van',
  },
  toLabel: {
    id: `${giftCardScope}.toLabel`,
    defaultMessage: 'Pour',
    en: 'To',
    es: 'Para',
    it: 'Per',
    de: 'Für',
    nl: 'Voor',
  },
  messageLabel: {
    id: `${giftCardScope}.messageLabel`,
    defaultMessage: 'Votre message',
    en: 'Your message',
    es: 'Tu mensaje',
    it: 'Il tuo messaggio',
    de: 'Ihre Nachricht',
    nl: 'Uw bericht',
  },
  buyerEmailEcard: {
    id: `${giftCardScope}.buyerEmailEcard`,
    defaultMessage: 'Votre email (pour le reçu)',
    en: 'Your email (for the receipt)',
    es: 'Tu email (para el recibo)',
    it: 'La tua email (per la ricevuta)',
    de: 'Ihre E-Mail (für die Quittung)',
    nl: 'Uw e-mail (voor het bewijs)',
  },
  buyerEmailPrint: {
    id: `${giftCardScope}.buyerEmailPrint`,
    defaultMessage: 'Votre email (la carte y sera envoyée)',
    en: 'Your email (the card is sent there)',
    es: 'Tu email (allí se enviará la tarjeta)',
    it: 'La tua email (la carta verrà inviata lì)',
    de: 'Ihre E-Mail (die Karte wird dorthin geschickt)',
    nl: 'Uw e-mail (de kaart wordt daarheen gestuurd)',
  },
  recipientEmail: {
    id: `${giftCardScope}.recipientEmail`,
    defaultMessage: 'Email du destinataire',
    en: "Recipient's email",
    es: 'Email del destinatario',
    it: 'Email del destinatario',
    de: 'E-Mail der beschenkten Person',
    nl: 'E-mail van de ontvanger',
  },
  whenLabel: {
    id: `${giftCardScope}.whenLabel`,
    defaultMessage: "Quand l'envoyer ?",
    en: 'When should it be sent?',
    es: '¿Cuándo enviarla?',
    it: 'Quando inviarla?',
    de: 'Wann soll sie verschickt werden?',
    nl: 'Wanneer versturen?',
  },
  sendNow: {
    id: `${giftCardScope}.sendNow`,
    defaultMessage: 'Dès le paiement',
    en: 'Once paid',
    es: 'Tras el pago',
    it: 'Dopo il pagamento',
    de: 'Nach der Zahlung',
    nl: 'Na betaling',
  },
  sendLater: {
    id: `${giftCardScope}.sendLater`,
    defaultMessage: 'À une date précise',
    en: 'On a chosen date',
    es: 'En una fecha concreta',
    it: 'In una data precisa',
    de: 'An einem bestimmten Datum',
    nl: 'Op een gekozen datum',
  },
  sendDate: {
    id: `${giftCardScope}.sendDate`,
    defaultMessage: "Date d'envoi",
    en: 'Sending date',
    es: 'Fecha de envío',
    it: 'Data di invio',
    de: 'Versanddatum',
    nl: 'Verzenddatum',
  },
  sendTime: {
    id: `${giftCardScope}.sendTime`,
    defaultMessage: "Heure d'envoi (heure de Paris)",
    en: 'Sending time (Paris time)',
    es: 'Hora de envío (hora de París)',
    it: 'Ora di invio (ora di Parigi)',
    de: 'Versandzeit (Pariser Zeit)',
    nl: 'Verzendtijd (Parijse tijd)',
  },
  invalidField: {
    id: `${giftCardScope}.invalidField`,
    defaultMessage: 'Ce champ est obligatoire ou mal rempli.',
    en: 'This field is required or invalid.',
    es: 'Este campo es obligatorio o no es válido.',
    it: 'Questo campo è obbligatorio o non valido.',
    de: 'Dieses Feld ist erforderlich oder ungültig.',
    nl: 'Dit veld is verplicht of ongeldig.',
  },
  totalLabel: {
    id: `${giftCardScope}.totalLabel`,
    defaultMessage: 'Total à payer',
    en: 'Total to pay',
    es: 'Total a pagar',
    it: 'Totale da pagare',
    de: 'Zu zahlender Betrag',
    nl: 'Totaal te betalen',
  },
  pay: {
    id: `${giftCardScope}.pay`,
    defaultMessage: 'Payer {amount}',
    en: 'Pay {amount}',
    es: 'Pagar {amount}',
    it: 'Paga {amount}',
    de: '{amount} bezahlen',
    nl: '{amount} betalen',
  },
  legal: {
    id: `${giftCardScope}.legal`,
    defaultMessage:
      'Paiement sécurisé par carte bancaire. Carte cadeau non remboursable.',
    en: 'Secure card payment. Gift card not refundable.',
    es: 'Pago seguro con tarjeta. Tarjeta regalo no reembolsable.',
    it: 'Pagamento sicuro con carta. Carta regalo non rimborsabile.',
    de: 'Sichere Kartenzahlung. Geschenkkarte nicht erstattungsfähig.',
    nl: 'Veilige betaling met kaart. Cadeaukaart niet terugbetaalbaar.',
  },
  preview: {
    id: `${giftCardScope}.preview`,
    defaultMessage: 'Aperçu',
    en: 'Preview',
    es: 'Vista previa',
    it: 'Anteprima',
    de: 'Vorschau',
    nl: 'Voorbeeld',
  },
  previewEmail: {
    id: `${giftCardScope}.previewEmail`,
    defaultMessage: "Aperçu de l'e-mail",
    en: 'Email preview',
    es: 'Vista previa del email',
    it: "Anteprima dell'email",
    de: 'Vorschau der E-Mail',
    nl: 'Voorbeeld van de e-mail',
  },
  previewToBlank: {
    id: `${giftCardScope}.previewToBlank`,
    defaultMessage: 'prénom du destinataire',
    en: "recipient's first name",
    es: 'nombre del destinatario',
    it: 'nome del destinatario',
    de: 'Vorname des Empfängers',
    nl: 'voornaam van de ontvanger',
  },
  previewFromBlank: {
    id: `${giftCardScope}.previewFromBlank`,
    defaultMessage: 'votre prénom',
    en: 'your first name',
    es: 'tu nombre',
    it: 'il tuo nome',
    de: 'Ihr Vorname',
    nl: 'uw voornaam',
  },
  previewRecipientEmailBlank: {
    id: `${giftCardScope}.previewRecipientEmailBlank`,
    defaultMessage: 'email du destinataire',
    en: "recipient's email",
    es: 'email del destinatario',
    it: 'email del destinatario',
    de: 'E-Mail des Empfängers',
    nl: 'e-mail van de ontvanger',
  },
  previewBuyerEmailBlank: {
    id: `${giftCardScope}.previewBuyerEmailBlank`,
    defaultMessage: 'votre email',
    en: 'your email',
    es: 'tu email',
    it: 'la tua email',
    de: 'Ihre E-Mail',
    nl: 'uw e-mail',
  },
  previewHello: {
    id: `${giftCardScope}.previewHello`,
    defaultMessage: 'Bonjour {name},',
    en: 'Hello {name},',
    es: 'Hola {name}:',
    it: 'Ciao {name},',
    de: 'Hallo {name},',
    nl: 'Hallo {name},',
  },
  previewText: {
    id: `${giftCardScope}.previewText`,
    defaultMessage:
      '{from} vous offre une carte cadeau Tictactrip de {amount} pour voyager en train ou en bus, où vous voulez.',
    en: '{from} gives you a {amount} Tictactrip gift card to travel by train or bus, wherever you like.',
    es: '{from} te regala una tarjeta regalo Tictactrip de {amount} para viajar en tren o autobús, adonde quieras.',
    it: '{from} ti regala una carta regalo Tictactrip da {amount} per viaggiare in treno o in autobus, dove vuoi.',
    de: '{from} schenkt Ihnen eine Tictactrip Geschenkkarte über {amount}, um mit Zug oder Bus zu reisen, wohin Sie wollen.',
    nl: '{from} geeft u een Tictactrip cadeaukaart van {amount} om met de trein of bus te reizen, waarheen u maar wilt.',
  },
  previewCode: {
    id: `${giftCardScope}.previewCode`,
    defaultMessage: 'Le code arrive avec la carte. Valable 1 an.',
    en: 'The code comes with the card. Valid for 1 year.',
    es: 'El código llega con la tarjeta. Válida 1 año.',
    it: 'Il codice arriva con la carta. Valida 1 anno.',
    de: 'Der Code kommt mit der Karte. 1 Jahr gültig.',
    nl: 'De code komt met de kaart. 1 jaar geldig.',
  },
  deliveryNow: {
    id: `${giftCardScope}.deliveryNow`,
    defaultMessage: "L'e-carte part à {recipient} dès le paiement.",
    en: 'The e-card goes to {recipient} once paid.',
    es: 'La tarjeta electrónica se envía a {recipient} tras el pago.',
    it: 'La carta digitale parte per {recipient} dopo il pagamento.',
    de: 'Die E-Karte geht nach der Zahlung an {recipient}.',
    nl: 'De e-kaart gaat na betaling naar {recipient}.',
  },
  deliveryLater: {
    id: `${giftCardScope}.deliveryLater`,
    defaultMessage: "L'e-carte part à {recipient} le {date} à {time}.",
    en: 'The e-card goes to {recipient} on {date} at {time}.',
    es: 'La tarjeta electrónica se envía a {recipient} el {date} a las {time}.',
    it: 'La carta digitale parte per {recipient} il {date} alle {time}.',
    de: 'Die E-Karte geht am {date} um {time} an {recipient}.',
    nl: 'De e-kaart gaat op {date} om {time} naar {recipient}.',
  },
  deliveryPrint: {
    id: `${giftCardScope}.deliveryPrint`,
    defaultMessage: 'La carte à imprimer part à {buyer} dès le paiement.',
    en: 'The card to print goes to {buyer} once paid.',
    es: 'La tarjeta para imprimir se envía a {buyer} tras el pago.',
    it: 'La carta da stampare parte per {buyer} dopo il pagamento.',
    de: 'Die Karte zum Ausdrucken geht nach der Zahlung an {buyer}.',
    nl: 'De kaart om te printen gaat na betaling naar {buyer}.',
  },
  paymentFailed: {
    id: `${giftCardScope}.paymentFailed`,
    defaultMessage:
      "Le paiement n'a pas abouti. Vous n'avez pas été débité, vous pouvez réessayer.",
    en: 'The payment did not go through. You were not charged, you can try again.',
    es: 'El pago no se ha realizado. No se te ha cobrado, puedes intentarlo de nuevo.',
    it: 'Il pagamento non è andato a buon fine. Non ti è stato addebitato nulla, puoi riprovare.',
    de: 'Die Zahlung ist fehlgeschlagen. Ihnen wurde nichts belastet, Sie können es erneut versuchen.',
    nl: 'De betaling is mislukt. Er is niets afgeschreven, u kunt het opnieuw proberen.',
  },
  createError: {
    id: `${giftCardScope}.createError`,
    defaultMessage:
      "La carte n'a pas pu être enregistrée. Vérifiez les champs puis réessayez.",
    en: 'The card could not be saved. Check the fields and try again.',
    es: 'No se ha podido guardar la tarjeta. Revisa los campos e inténtalo de nuevo.',
    it: 'Impossibile salvare la carta. Controlla i campi e riprova.',
    de: 'Die Karte konnte nicht gespeichert werden. Prüfen Sie die Felder und versuchen Sie es erneut.',
    nl: 'De kaart kon niet worden opgeslagen. Controleer de velden en probeer het opnieuw.',
  },
  waitConfirmation: {
    id: `${giftCardScope}.waitConfirmation`,
    defaultMessage: 'Nous attendons la confirmation de votre banque…',
    en: "Waiting for your bank's confirmation…",
    es: 'Esperando la confirmación de tu banco…',
    it: 'In attesa della conferma della tua banca…',
    de: 'Wir warten auf die Bestätigung Ihrer Bank…',
    nl: 'We wachten op de bevestiging van uw bank…',
  },
  successTitle: {
    id: `${giftCardScope}.successTitle`,
    defaultMessage: 'Merci, votre carte cadeau est prête',
    en: 'Thank you, your gift card is ready',
    es: 'Gracias, tu tarjeta regalo está lista',
    it: 'Grazie, la tua carta regalo è pronta',
    de: 'Danke, Ihre Geschenkkarte ist bereit',
    nl: 'Bedankt, uw cadeaukaart is klaar',
  },
  successText: {
    id: `${giftCardScope}.successText`,
    defaultMessage:
      "Votre reçu part par email. Le code n'apparaît que dans l'email de la carte.",
    en: 'Your receipt is on its way by email. The code only appears in the card email.',
    es: 'Tu recibo llega por email. El código solo aparece en el email de la tarjeta.',
    it: "La ricevuta arriva via email. Il codice compare solo nell'email della carta.",
    de: 'Ihre Quittung kommt per E-Mail. Der Code steht nur in der E-Mail der Karte.',
    nl: 'Uw bewijs komt per e-mail. De code staat alleen in de e-mail van de kaart.',
  },
  offerAnother: {
    id: `${giftCardScope}.offerAnother`,
    defaultMessage: 'Offrir une autre carte',
    en: 'Give another card',
    es: 'Regalar otra tarjeta',
    it: "Regala un'altra carta",
    de: 'Eine weitere Karte verschenken',
    nl: 'Nog een kaart geven',
  },
  redeemTitle: {
    id: `${giftCardScope}.redeemTitle`,
    defaultMessage: "Votre voyage vous attend, c'est cadeau",
    en: "Your trip is waiting, it's a gift",
    es: 'Tu viaje te espera, es un regalo',
    it: 'Il tuo viaggio ti aspetta, è un regalo',
    de: 'Ihre Reise wartet, sie ist ein Geschenk',
    nl: 'Uw reis wacht, het is een cadeau',
  },
  redeemText: {
    id: `${giftCardScope}.redeemText`,
    defaultMessage: 'Saisissez votre code pour voir votre solde.',
    en: 'Type your code to see your balance.',
    es: 'Introduce tu código para ver tu saldo.',
    it: 'Inserisci il codice per vedere il saldo.',
    de: 'Geben Sie Ihren Code ein, um Ihr Guthaben zu sehen.',
    nl: 'Vul uw code in om uw saldo te zien.',
  },
  checkBalance: {
    id: `${giftCardScope}.checkBalance`,
    defaultMessage: 'Voir mon solde',
    en: 'See my balance',
    es: 'Ver mi saldo',
    it: 'Vedi il mio saldo',
    de: 'Mein Guthaben ansehen',
    nl: 'Mijn saldo bekijken',
  },
  unknownCode: {
    id: `${giftCardScope}.unknownCode`,
    defaultMessage:
      "Ce code n'existe pas. Vérifiez les lettres et les chiffres.",
    en: 'This code does not exist. Check the letters and digits.',
    es: 'Este código no existe. Revisa las letras y los números.',
    it: 'Questo codice non esiste. Controlla lettere e numeri.',
    de: 'Dieser Code existiert nicht. Prüfen Sie Buchstaben und Ziffern.',
    nl: 'Deze code bestaat niet. Controleer de letters en cijfers.',
  },
  notUsable: {
    id: `${giftCardScope}.notUsable`,
    defaultMessage:
      "Cette carte n'est plus utilisable : elle est vide ou a expiré.",
    en: 'This card can no longer be used: it is empty or expired.',
    es: 'Esta tarjeta ya no se puede usar: está vacía o ha caducado.',
    it: 'Questa carta non è più utilizzabile: è vuota o scaduta.',
    de: 'Diese Karte ist nicht mehr nutzbar: Sie ist leer oder abgelaufen.',
    nl: 'Deze kaart is niet meer bruikbaar: hij is leeg of verlopen.',
  },
  balance: {
    id: `${giftCardScope}.balance`,
    defaultMessage: '{balance} disponibles sur {initial}',
    en: '{balance} left of {initial}',
    es: '{balance} disponibles de {initial}',
    it: '{balance} disponibili su {initial}',
    de: '{balance} von {initial} verfügbar',
    nl: '{balance} beschikbaar van {initial}',
  },
  validUntil: {
    id: `${giftCardScope}.validUntil`,
    defaultMessage: "Valable jusqu'au {date}. Offerte par {from}.",
    en: 'Valid until {date}. Given by {from}.',
    es: 'Válida hasta el {date}. Regalo de {from}.',
    it: 'Valida fino al {date}. Regalata da {from}.',
    de: 'Gültig bis {date}. Geschenk von {from}.',
    nl: 'Geldig tot {date}. Gegeven door {from}.',
  },
  codeKept: {
    id: `${giftCardScope}.codeKept`,
    defaultMessage:
      'Le code est gardé : il sera déjà rempli au moment de payer.',
    en: 'The code is kept: it will already be filled in when you pay.',
    es: 'El código se guarda: ya estará rellenado al pagar.',
    it: 'Il codice viene salvato: sarà già inserito al pagamento.',
    de: 'Der Code wird gespeichert: Er ist beim Bezahlen bereits eingetragen.',
    nl: 'De code wordt bewaard: hij is al ingevuld bij het betalen.',
  },
  searchTrip: {
    id: `${giftCardScope}.searchTrip`,
    defaultMessage: 'Chercher un trajet',
    en: 'Search for a trip',
    es: 'Buscar un viaje',
    it: 'Cerca un viaggio',
    de: 'Reise suchen',
    nl: 'Reis zoeken',
  },
  redeemStep1: {
    id: `${giftCardScope}.redeemStep1`,
    defaultMessage:
      'Saisissez votre code pour voir le solde et la date de fin.',
    en: 'Enter your code to see the balance and the end date.',
    es: 'Introduzca su código para ver el saldo y la fecha de fin.',
    it: 'Inserisca il codice per vedere il saldo e la data di scadenza.',
    de: 'Geben Sie Ihren Code ein, um Guthaben und Ablaufdatum zu sehen.',
    nl: 'Voer uw code in om het saldo en de einddatum te zien.',
  },
  redeemStep2: {
    id: `${giftCardScope}.redeemStep2`,
    defaultMessage:
      'Cherchez votre trajet en train ou en bus, partout en France et en Europe.',
    en: 'Search for your train or bus trip, anywhere in France and Europe.',
    es: 'Busque su viaje en tren o en autobús, en Francia y en Europa.',
    it: 'Cerchi il suo viaggio in treno o in autobus, in Francia e in Europa.',
    de: 'Suchen Sie Ihre Zug- oder Busreise in Frankreich und Europa.',
    nl: 'Zoek uw trein- of busreis, in heel Frankrijk en Europa.',
  },
  redeemStep3: {
    id: `${giftCardScope}.redeemStep3`,
    defaultMessage:
      'Au paiement, le code est déjà rempli. Le reste du solde garde sa date de fin.',
    en: 'At payment, the code is already filled in. The rest of the balance keeps its end date.',
    es: 'Al pagar, el código ya está rellenado. El resto del saldo conserva su fecha de fin.',
    it: 'Al pagamento il codice è già inserito. Il saldo restante mantiene la sua scadenza.',
    de: 'Beim Bezahlen ist der Code bereits eingetragen. Das Restguthaben behält sein Ablaufdatum.',
    nl: 'Bij het betalen is de code al ingevuld. Het resterende saldo houdt zijn einddatum.',
  },
  promoTitle: {
    id: `${giftCardScope}.promoTitle`,
    defaultMessage: 'Code promo ou carte cadeau',
    en: 'Promo code or gift card',
    es: 'Código promocional o tarjeta regalo',
    it: 'Codice promozionale o carta regalo',
    de: 'Gutscheincode oder Geschenkkarte',
    nl: 'Promotiecode of cadeaukaart',
  },
  promoPlaceholder: {
    id: `${giftCardScope}.promoPlaceholder`,
    defaultMessage: 'Votre code',
    en: 'Your code',
    es: 'Tu código',
    it: 'Il tuo codice',
    de: 'Ihr Code',
    nl: 'Uw code',
  },
  apply: {
    id: `${giftCardScope}.apply`,
    defaultMessage: 'Appliquer',
    en: 'Apply',
    es: 'Aplicar',
    it: 'Applica',
    de: 'Anwenden',
    nl: 'Toepassen',
  },
  removeCode: {
    id: `${giftCardScope}.removeCode`,
    defaultMessage: 'Retirer le code {code}',
    en: 'Remove code {code}',
    es: 'Quitar el código {code}',
    it: 'Rimuovi il codice {code}',
    de: 'Code {code} entfernen',
    nl: 'Code {code} verwijderen',
  },
  promoHint: {
    id: `${giftCardScope}.promoHint`,
    defaultMessage:
      'Un code promo par commande. Les cartes cadeaux se cumulent.',
    en: 'One promo code per order. Gift cards can be combined.',
    es: 'Un código promocional por pedido. Las tarjetas regalo se pueden combinar.',
    it: 'Un codice promozionale per ordine. Le carte regalo si possono combinare.',
    de: 'Ein Gutscheincode pro Bestellung. Geschenkkarten sind kombinierbar.',
    nl: 'Eén promotiecode per bestelling. Cadeaukaarten kunnen worden gecombineerd.',
  },
  discountLine: {
    id: `${giftCardScope}.discountLine`,
    defaultMessage: 'Code {code}',
    en: 'Code {code}',
    es: 'Código {code}',
    it: 'Codice {code}',
    de: 'Code {code}',
    nl: 'Code {code}',
  },
  giftCardLine: {
    id: `${giftCardScope}.giftCardLine`,
    defaultMessage: 'Carte cadeau {code}',
    en: 'Gift card {code}',
    es: 'Tarjeta regalo {code}',
    it: 'Carta regalo {code}',
    de: 'Geschenkkarte {code}',
    nl: 'Cadeaukaart {code}',
  },
  nothingToPay: {
    id: `${giftCardScope}.nothingToPay`,
    defaultMessage: 'Rien à payer : vos codes couvrent toute la commande.',
    en: 'Nothing to pay: your codes cover the whole order.',
    es: 'Nada que pagar: tus códigos cubren todo el pedido.',
    it: "Niente da pagare: i tuoi codici coprono tutto l'ordine.",
    de: 'Nichts zu bezahlen: Ihre Codes decken die gesamte Bestellung.',
    nl: 'Niets te betalen: uw codes dekken de hele bestelling.',
  },
  refusalUnknown: {
    id: `${giftCardScope}.refusalUnknown`,
    defaultMessage: "Ce code n'existe pas. Vérifiez l'orthographe.",
    en: 'This code does not exist. Check the spelling.',
    es: 'Este código no existe. Revisa la ortografía.',
    it: "Questo codice non esiste. Controlla l'ortografia.",
    de: 'Dieser Code existiert nicht. Prüfen Sie die Schreibweise.',
    nl: 'Deze code bestaat niet. Controleer de spelling.',
  },
  refusalNotValid: {
    id: `${giftCardScope}.refusalNotValid`,
    defaultMessage: "Ce code n'est pas valable en ce moment.",
    en: 'This code is not valid right now.',
    es: 'Este código no es válido en este momento.',
    it: 'Questo codice non è valido in questo momento.',
    de: 'Dieser Code ist derzeit nicht gültig.',
    nl: 'Deze code is op dit moment niet geldig.',
  },
  refusalUsedUp: {
    id: `${giftCardScope}.refusalUsedUp`,
    defaultMessage: 'Ce code a déjà été utilisé autant de fois que possible.',
    en: 'This code has already been used as many times as allowed.',
    es: 'Este código ya se ha usado el máximo de veces.',
    it: 'Questo codice è già stato usato il numero massimo di volte.',
    de: 'Dieser Code wurde bereits so oft wie erlaubt verwendet.',
    nl: 'Deze code is al zo vaak gebruikt als toegestaan.',
  },
  refusalFirstOrder: {
    id: `${giftCardScope}.refusalFirstOrder`,
    defaultMessage: 'Ce code est réservé à une première commande.',
    en: 'This code is for a first order only.',
    es: 'Este código es solo para un primer pedido.',
    it: 'Questo codice è riservato al primo ordine.',
    de: 'Dieser Code gilt nur für eine erste Bestellung.',
    nl: 'Deze code is alleen voor een eerste bestelling.',
  },
  refusalEmail: {
    id: `${giftCardScope}.refusalEmail`,
    defaultMessage: 'Ce code est réservé à une autre adresse email.',
    en: 'This code is for another email address.',
    es: 'Este código es para otra dirección de email.',
    it: 'Questo codice è riservato a un altro indirizzo email.',
    de: 'Dieser Code ist für eine andere E-Mail-Adresse.',
    nl: 'Deze code is voor een ander e-mailadres.',
  },
  refusalEmailMissing: {
    id: `${giftCardScope}.refusalEmailMissing`,
    defaultMessage:
      'Ce code est réservé à certaines adresses email. Saisissez votre adresse email pour l’utiliser.',
    en: 'This code is for some email addresses only. Enter your email address to use it.',
    es: 'Este código es solo para algunas direcciones de email. Introduce tu dirección de email para usarlo.',
    it: 'Questo codice è riservato ad alcuni indirizzi email. Inserisci il tuo indirizzo email per usarlo.',
    de: 'Dieser Code gilt nur für bestimmte E-Mail-Adressen. Geben Sie Ihre E-Mail-Adresse ein, um ihn zu nutzen.',
    nl: 'Deze code is alleen voor bepaalde e-mailadressen. Vul je e-mailadres in om hem te gebruiken.',
  },
  refusalMinOrder: {
    id: `${giftCardScope}.refusalMinOrder`,
    defaultMessage:
      "Le montant minimum de commande de ce code n'est pas atteint.",
    en: "This code's minimum order amount is not reached.",
    es: 'No se alcanza el importe mínimo de pedido de este código.',
    it: "L'importo minimo dell'ordine per questo codice non è raggiunto.",
    de: 'Der Mindestbestellwert dieses Codes ist nicht erreicht.',
    nl: 'Het minimale bestelbedrag van deze code is niet bereikt.',
  },
  refusalScope: {
    id: `${giftCardScope}.refusalScope`,
    defaultMessage: "Ce code ne s'applique pas à ce voyage.",
    en: 'This code does not apply to this trip.',
    es: 'Este código no se aplica a este viaje.',
    it: 'Questo codice non si applica a questo viaggio.',
    de: 'Dieser Code gilt nicht für diese Reise.',
    nl: 'Deze code geldt niet voor deze reis.',
  },
  refusalOnePromo: {
    id: `${giftCardScope}.refusalOnePromo`,
    defaultMessage:
      'Un seul code promo par commande. Les cartes cadeaux, elles, se cumulent.',
    en: 'Only one promo code per order. Gift cards can be combined.',
    es: 'Solo un código promocional por pedido. Las tarjetas regalo sí se combinan.',
    it: 'Un solo codice promozionale per ordine. Le carte regalo invece si combinano.',
    de: 'Nur ein Gutscheincode pro Bestellung. Geschenkkarten sind kombinierbar.',
    nl: 'Slechts één promotiecode per bestelling. Cadeaukaarten kunnen wel worden gecombineerd.',
  },
  refusalNotStackable: {
    id: `${giftCardScope}.refusalNotStackable`,
    defaultMessage: 'Ce code ne se cumule pas avec un autre code.',
    en: 'This code cannot be combined with another code.',
    es: 'Este código no se combina con otro código.',
    it: 'Questo codice non è cumulabile con un altro codice.',
    de: 'Dieser Code ist nicht mit einem anderen Code kombinierbar.',
    nl: 'Deze code kan niet met een andere code worden gecombineerd.',
  },
  refusalAlreadyApplied: {
    id: `${giftCardScope}.refusalAlreadyApplied`,
    defaultMessage: 'Ce code est déjà appliqué.',
    en: 'This code is already applied.',
    es: 'Este código ya está aplicado.',
    it: 'Questo codice è già applicato.',
    de: 'Dieser Code ist bereits angewendet.',
    nl: 'Deze code is al toegepast.',
  },
  refusalNothingToPay: {
    id: `${giftCardScope}.refusalNothingToPay`,
    defaultMessage: 'Votre commande est déjà entièrement payée.',
    en: 'Your order is already fully paid.',
    es: 'Tu pedido ya está pagado por completo.',
    it: 'Il tuo ordine è già interamente pagato.',
    de: 'Ihre Bestellung ist bereits vollständig bezahlt.',
    nl: 'Uw bestelling is al volledig betaald.',
  },
  offerNote: {
    id: `${giftCardScope}.offerNote`,
    defaultMessage:
      'Offre voyageur : −{percent} % sur cette carte. Elle sera utilisable pour des voyages à partir du {travelFrom}. Offre valable jusqu’au {expiresAt}.',
    en: 'Travellers offer: −{percent}% on this card. It can be used for trips from {travelFrom}. Offer valid until {expiresAt}.',
    es: 'Oferta viajero: −{percent} % en esta tarjeta. Se podrá usar para viajes a partir del {travelFrom}. Oferta válida hasta el {expiresAt}.',
    it: 'Offerta viaggiatore: −{percent}% su questa carta. Sarà utilizzabile per viaggi dal {travelFrom}. Offerta valida fino al {expiresAt}.',
    de: 'Reisenden-Angebot: −{percent} % auf diese Karte. Sie gilt für Reisen ab dem {travelFrom}. Angebot gültig bis {expiresAt}.',
    nl: 'Reizigersaanbod: −{percent}% op deze kaart. Te gebruiken voor reizen vanaf {travelFrom}. Aanbod geldig tot {expiresAt}.',
  },
  offerLine: {
    id: `${giftCardScope}.offerLine`,
    defaultMessage: 'Offre voyageur −{percent} %',
    en: 'Travellers offer −{percent}%',
    es: 'Oferta viajero −{percent} %',
    it: 'Offerta viaggiatore −{percent}%',
    de: 'Reisenden-Angebot −{percent} %',
    nl: 'Reizigersaanbod −{percent}%',
  },
  refusalEmailNotVerified: {
    id: `${giftCardScope}.refusalEmailNotVerified`,
    defaultMessage:
      'Ce code est réservé à certaines adresses. Nous avons envoyé un code à 6 chiffres à votre email : saisissez-le pour l’utiliser.',
    en: 'This code is kept for some addresses. We sent a 6 digit code to your email: type it to use the code.',
    es: 'Este código está reservado a algunas direcciones. Te hemos enviado un código de 6 cifras por email: introdúcelo para usarlo.',
    it: 'Questo codice è riservato ad alcuni indirizzi. Ti abbiamo inviato un codice di 6 cifre via email: inseriscilo per usarlo.',
    de: 'Dieser Code gilt nur für bestimmte Adressen. Wir haben Ihnen einen 6-stelligen Code per E-Mail geschickt: Geben Sie ihn ein, um den Code zu nutzen.',
    nl: 'Deze code geldt alleen voor bepaalde adressen. We hebben u een code van 6 cijfers gemaild: vul die in om de code te gebruiken.',
  },
  refusalOwnOfferCard: {
    id: `${giftCardScope}.refusalOwnOfferCard`,
    defaultMessage:
      'Cette carte a été achetée avec l’offre voyageur : elle est à offrir et ne paie pas vos propres voyages.',
    en: 'This card was bought with the travellers offer: it is a gift and does not pay for your own trips.',
    es: 'Esta tarjeta se compró con la oferta viajero: es para regalar y no paga tus propios viajes.',
    it: 'Questa carta è stata acquistata con l’offerta viaggiatore: è da regalare e non paga i tuoi viaggi.',
    de: 'Diese Karte wurde mit dem Reisenden-Angebot gekauft: Sie ist zum Verschenken und bezahlt nicht Ihre eigenen Reisen.',
    nl: 'Deze kaart is gekocht met de reizigersaanbieding: hij is om cadeau te doen en betaalt niet voor uw eigen reizen.',
  },
  emailCheckLabel: {
    id: `${giftCardScope}.emailCheckLabel`,
    defaultMessage: 'Code reçu par email',
    en: 'Code received by email',
    es: 'Código recibido por email',
    it: 'Codice ricevuto via email',
    de: 'Per E-Mail erhaltener Code',
    nl: 'Code ontvangen per e-mail',
  },
  emailCheckSubmit: {
    id: `${giftCardScope}.emailCheckSubmit`,
    defaultMessage: 'Valider',
    en: 'Confirm',
    es: 'Validar',
    it: 'Conferma',
    de: 'Bestätigen',
    nl: 'Bevestigen',
  },
  emailCheckResend: {
    id: `${giftCardScope}.emailCheckResend`,
    defaultMessage: 'Renvoyer un code',
    en: 'Send a new code',
    es: 'Enviar otro código',
    it: 'Invia un nuovo codice',
    de: 'Neuen Code senden',
    nl: 'Nieuwe code sturen',
  },
  emailCheckWrong: {
    id: `${giftCardScope}.emailCheckWrong`,
    defaultMessage: 'Ce code n’est pas le bon. Vérifiez l’email et réessayez.',
    en: 'This is not the right code. Check the email and try again.',
    es: 'Este código no es correcto. Revisa el email e inténtalo de nuevo.',
    it: 'Il codice non è corretto. Controlla l’email e riprova.',
    de: 'Der Code ist falsch. Prüfen Sie die E-Mail und versuchen Sie es erneut.',
    nl: 'Deze code klopt niet. Controleer de e-mail en probeer het opnieuw.',
  },
  emailCheckExpired: {
    id: `${giftCardScope}.emailCheckExpired`,
    defaultMessage: 'Ce code n’est plus valable : demandez-en un nouveau.',
    en: 'This code is no longer valid: ask for a new one.',
    es: 'Este código ya no es válido: pide uno nuevo.',
    it: 'Il codice non è più valido: richiedine uno nuovo.',
    de: 'Dieser Code ist nicht mehr gültig: Fordern Sie einen neuen an.',
    nl: 'Deze code is niet meer geldig: vraag een nieuwe aan.',
  },
  refusalAncillaryMissing: {
    id: `${giftCardScope}.refusalAncillaryMissing`,
    defaultMessage:
      'Ce code offre une option : ajoutez-la à votre commande pour l’utiliser.',
    en: 'This code gives an option: add it to your order to use the code.',
    es: 'Este código regala una opción: añádela a tu pedido para usarlo.',
    it: 'Questo codice regala un’opzione: aggiungila al tuo ordine per usarlo.',
    de: 'Dieser Code schenkt eine Option: Fügen Sie sie Ihrer Bestellung hinzu, um ihn zu nutzen.',
    nl: 'Deze code geeft een optie cadeau: voeg die toe aan uw bestelling om de code te gebruiken.',
  },
  refusalNoBalance: {
    id: `${giftCardScope}.refusalNoBalance`,
    defaultMessage: 'Cette carte cadeau est vide.',
    en: 'This gift card is empty.',
    es: 'Esta tarjeta regalo está vacía.',
    it: 'Questa carta regalo è vuota.',
    de: 'Diese Geschenkkarte ist leer.',
    nl: 'Deze cadeaukaart is leeg.',
  },
  promoError: {
    id: `${giftCardScope}.promoError`,
    defaultMessage:
      "Les codes n'ont pas pu être vérifiés. Réessayez dans un instant.",
    en: 'The codes could not be checked. Try again in a moment.',
    es: 'No se han podido comprobar los códigos. Inténtalo de nuevo en un momento.',
    it: 'Impossibile verificare i codici. Riprova tra un istante.',
    de: 'Die Codes konnten nicht geprüft werden. Versuchen Sie es gleich noch einmal.',
    nl: 'De codes konden niet worden gecontroleerd. Probeer het zo opnieuw.',
  },
  occasionsTitle: {
    id: `${giftCardScope}.occasionsTitle`,
    defaultMessage: 'Pour quelle occasion ?',
    en: 'For which occasion?',
    es: '¿Para qué ocasión?',
    it: 'Per quale occasione?',
    de: 'Zu welchem Anlass?',
    nl: 'Voor welke gelegenheid?',
  },
  occasionChristmas: {
    id: `${giftCardScope}.occasionChristmas`,
    defaultMessage: 'Noël',
    en: 'Christmas',
    es: 'Navidad',
    it: 'Natale',
    de: 'Weihnachten',
    nl: 'Kerstmis',
  },
  occasionBirthday: {
    id: `${giftCardScope}.occasionBirthday`,
    defaultMessage: 'Anniversaire',
    en: 'Birthday',
    es: 'Cumpleaños',
    it: 'Compleanno',
    de: 'Geburtstag',
    nl: 'Verjaardag',
  },
  occasionValentine: {
    id: `${giftCardScope}.occasionValentine`,
    defaultMessage: 'Saint-Valentin',
    en: "Valentine's Day",
    es: 'San Valentín',
    it: 'San Valentino',
    de: 'Valentinstag',
    nl: 'Valentijnsdag',
  },
  occasionMothers: {
    id: `${giftCardScope}.occasionMothers`,
    defaultMessage: 'Fête des mères',
    en: "Mother's Day",
    es: 'Día de la Madre',
    it: 'Festa della mamma',
    de: 'Muttertag',
    nl: 'Moederdag',
  },
  occasionFathers: {
    id: `${giftCardScope}.occasionFathers`,
    defaultMessage: 'Fête des pères',
    en: "Father's Day",
    es: 'Día del Padre',
    it: 'Festa del papà',
    de: 'Vatertag',
    nl: 'Vaderdag',
  },
  occasionWedding: {
    id: `${giftCardScope}.occasionWedding`,
    defaultMessage: 'Mariage',
    en: 'Wedding',
    es: 'Boda',
    it: 'Matrimonio',
    de: 'Hochzeit',
    nl: 'Bruiloft',
  },
  occasionRetirement: {
    id: `${giftCardScope}.occasionRetirement`,
    defaultMessage: 'Départ à la retraite',
    en: 'Retirement',
    es: 'Jubilación',
    it: 'Pensionamento',
    de: 'Ruhestand',
    nl: 'Pensioen',
  },
  occasionJustBecause: {
    id: `${giftCardScope}.occasionJustBecause`,
    defaultMessage: 'Juste comme ça',
    en: 'Just because',
    es: 'Porque sí',
    it: 'Così, senza motivo',
    de: 'Einfach so',
    nl: 'Zomaar',
  },
  mostOffered: {
    id: `${giftCardScope}.mostOffered`,
    defaultMessage: 'Le plus offert',
    en: 'Most given',
    es: 'La más regalada',
    it: 'La più regalata',
    de: 'Am häufigsten verschenkt',
    nl: 'Meest gegeven',
  },
  balanceLeft: {
    id: `${giftCardScope}.balanceLeft`,
    defaultMessage: 'Il restera {balance} sur la carte',
    en: '{balance} will stay on the card',
    es: 'Quedarán {balance} en la tarjeta',
    it: 'Resteranno {balance} sulla carta',
    de: '{balance} bleiben auf der Karte',
    nl: 'Er blijft {balance} op de kaart',
  },
  deliveryTitle: {
    id: `${giftCardScope}.deliveryTitle`,
    defaultMessage: "Changer l'envoi de la carte",
    en: "Change the card's delivery",
    es: 'Cambiar el envío de la tarjeta',
    it: "Modificare l'invio della carta",
    de: 'Versand der Karte ändern',
    nl: 'Verzending van de kaart wijzigen',
  },
  deliveryText: {
    id: `${giftCardScope}.deliveryText`,
    defaultMessage:
      "{toName} recevra la carte par email. Vous pouvez changer l'adresse et la date jusqu'à l'envoi.",
    en: '{toName} will receive the card by email. You can change the address and the date until it is sent.',
    es: '{toName} recibirá la tarjeta por email. Puede cambiar la dirección y la fecha hasta el envío.',
    it: "{toName} riceverà la carta via email. Può modificare l'indirizzo e la data fino all'invio.",
    de: '{toName} erhält die Karte per E-Mail. Adresse und Datum können Sie bis zum Versand ändern.',
    nl: '{toName} ontvangt de kaart per e-mail. U kunt het adres en de datum wijzigen tot de verzending.',
  },
  deliverySave: {
    id: `${giftCardScope}.deliverySave`,
    defaultMessage: 'Enregistrer',
    en: 'Save',
    es: 'Guardar',
    it: 'Salva',
    de: 'Speichern',
    nl: 'Opslaan',
  },
  deliverySavedLater: {
    id: `${giftCardScope}.deliverySavedLater`,
    defaultMessage: "C'est noté : la carte partira le {date} à {email}.",
    en: 'Done: the card will leave on {date} to {email}.',
    es: 'Hecho: la tarjeta saldrá el {date} a {email}.',
    it: 'Fatto: la carta partirà il {date} a {email}.',
    de: 'Erledigt: Die Karte geht am {date} an {email}.',
    nl: 'Genoteerd: de kaart vertrekt op {date} naar {email}.',
  },
  deliverySavedNow: {
    id: `${giftCardScope}.deliverySavedNow`,
    defaultMessage: "C'est envoyé : la carte part maintenant à {email}.",
    en: 'Sent: the card is leaving now to {email}.',
    es: 'Enviado: la tarjeta sale ahora a {email}.',
    it: 'Inviata: la carta parte ora a {email}.',
    de: 'Gesendet: Die Karte geht jetzt an {email}.',
    nl: 'Verzonden: de kaart vertrekt nu naar {email}.',
  },
  deliveryAlreadySent: {
    id: `${giftCardScope}.deliveryAlreadySent`,
    defaultMessage:
      'Cette carte est déjà partie : sa date et son destinataire ne peuvent plus changer.',
    en: 'This card has already left: its date and recipient can no longer change.',
    es: 'Esta tarjeta ya se envió: su fecha y su destinatario ya no pueden cambiar.',
    it: 'Questa carta è già partita: data e destinatario non possono più cambiare.',
    de: 'Diese Karte wurde bereits versendet: Datum und Empfänger lassen sich nicht mehr ändern.',
    nl: 'Deze kaart is al verzonden: datum en ontvanger kunnen niet meer wijzigen.',
  },
  deliveryInvalidLink: {
    id: `${giftCardScope}.deliveryInvalidLink`,
    defaultMessage:
      "Ce lien n'est pas valable. Utilisez celui de votre email de confirmation.",
    en: 'This link is not valid. Use the one in your confirmation email.',
    es: 'Este enlace no es válido. Use el de su email de confirmación.',
    it: 'Questo link non è valido. Usi quello della sua email di conferma.',
    de: 'Dieser Link ist ungültig. Verwenden Sie den Link aus Ihrer Bestätigungs-E-Mail.',
    nl: 'Deze link is niet geldig. Gebruik die uit uw bevestigingsmail.',
  },
  deliveryError: {
    id: `${giftCardScope}.deliveryError`,
    defaultMessage:
      "La date ou l'adresse n'est pas valable. Vérifiez-les et réessayez.",
    en: 'The date or the address is not valid. Check them and try again.',
    es: 'La fecha o la dirección no es válida. Revíselas e inténtelo de nuevo.',
    it: "La data o l'indirizzo non è valido. Li controlli e riprovi.",
    de: 'Datum oder Adresse ist ungültig. Bitte prüfen und erneut versuchen.',
    nl: 'De datum of het adres is niet geldig. Controleer ze en probeer opnieuw.',
  },
  occasionMetaTitle: {
    id: `${giftCardScope}.occasionMetaTitle`,
    defaultMessage:
      'Carte cadeau {occasion} : offrez un voyage en train ou en bus',
    en: '{occasion} gift card: give a train or bus trip',
    es: 'Tarjeta regalo {occasion}: regale un viaje en tren o autobús',
    it: 'Carta regalo {occasion}: regala un viaggio in treno o autobus',
    de: 'Geschenkkarte {occasion}: Verschenken Sie eine Zug- oder Busreise',
    nl: 'Cadeaukaart {occasion}: geef een trein- of busreis cadeau',
  },
  occasionMetaDescription: {
    id: `${giftCardScope}.occasionMetaDescription`,
    defaultMessage:
      'Carte cadeau {occasion} : train ou bus en France et en Europe, montant libre dès 10 €, e-carte envoyée le jour choisi, valable 1 an.',
    en: '{occasion} gift card: train or bus in France and Europe, any amount from €10, e-card sent on the day you choose, valid 1 year.',
    es: 'Tarjeta regalo {occasion}: tren o autobús en Francia y Europa, importe libre desde 10 €, e-tarjeta enviada el día elegido, válida 1 año.',
    it: 'Carta regalo {occasion}: treno o autobus in Francia e in Europa, importo libero da 10 €, e-card inviata il giorno scelto, valida 1 anno.',
    de: 'Geschenkkarte {occasion}: Zug oder Bus in Frankreich und Europa, freier Betrag ab 10 €, E-Karte am gewünschten Tag, 1 Jahr gültig.',
    nl: 'Cadeaukaart {occasion}: trein of bus in Frankrijk en Europa, vrij bedrag vanaf € 10, e-kaart op de gekozen dag verstuurd, 1 jaar geldig.',
  },
  occasionEyebrow: {
    id: `${giftCardScope}.occasionEyebrow`,
    defaultMessage: 'Carte cadeau · {occasion}',
    en: 'Gift card · {occasion}',
    es: 'Tarjeta regalo · {occasion}',
    it: 'Carta regalo · {occasion}',
    de: 'Geschenkkarte · {occasion}',
    nl: 'Cadeaukaart · {occasion}',
  },
  noelTitle: {
    id: `${giftCardScope}.noelTitle`,
    defaultMessage: 'Offrez un voyage pour Noël',
    en: 'Give a trip for Christmas',
    es: 'Regale un viaje por Navidad',
    it: 'Regala un viaggio per Natale',
    de: 'Verschenken Sie eine Reise zu Weihnachten',
    nl: 'Geef een reis cadeau met Kerstmis',
  },
  noelText: {
    id: `${giftCardScope}.noelText`,
    defaultMessage:
      "Sous le sapin, un voyage vers la destination de leur choix. L'e-carte peut arriver le 25 décembre au matin.",
    en: 'Under the tree, a trip to the destination of their choice. The e-card can arrive on the morning of 25 December.',
    es: 'Bajo el árbol, un viaje al destino que elijan. La e-tarjeta puede llegar la mañana del 25 de diciembre.',
    it: "Sotto l'albero, un viaggio verso la meta che preferiscono. La e-card può arrivare la mattina del 25 dicembre.",
    de: 'Unter dem Baum eine Reise an ein Ziel ihrer Wahl. Die E-Karte kann am Morgen des 25. Dezember ankommen.',
    nl: 'Onder de boom een reis naar de bestemming van hun keuze. De e-kaart kan op de ochtend van 25 december aankomen.',
  },
  anniversaireTitle: {
    id: `${giftCardScope}.anniversaireTitle`,
    defaultMessage: 'Un anniversaire, une destination',
    en: 'A birthday, a destination',
    es: 'Un cumpleaños, un destino',
    it: 'Un compleanno, una meta',
    de: 'Ein Geburtstag, ein Reiseziel',
    nl: 'Een verjaardag, een bestemming',
  },
  anniversaireText: {
    id: `${giftCardScope}.anniversaireText`,
    defaultMessage:
      "Pour son anniversaire, offrez le voyage de son choix. L'e-carte arrive le jour J, à l'heure que vous choisissez.",
    en: 'For their birthday, give the trip of their choice. The e-card arrives on the day, at the time you choose.',
    es: 'Por su cumpleaños, regale el viaje que elija. La e-tarjeta llega el día señalado, a la hora que usted elija.',
    it: "Per il suo compleanno, regali il viaggio che preferisce. La e-card arriva il giorno stesso, all'ora che sceglie lei.",
    de: 'Schenken Sie zum Geburtstag die Reise seiner Wahl. Die E-Karte kommt am Tag selbst, zur gewünschten Uhrzeit.',
    nl: 'Geef voor de verjaardag de reis van hun keuze. De e-kaart komt op de dag zelf, op het uur dat u kiest.',
  },
  saintValentinTitle: {
    id: `${giftCardScope}.saintValentinTitle`,
    defaultMessage: 'Un week-end à deux pour la Saint-Valentin',
    en: "A weekend for two for Valentine's Day",
    es: 'Un fin de semana para dos por San Valentín',
    it: 'Un weekend per due a San Valentino',
    de: 'Ein Wochenende zu zweit zum Valentinstag',
    nl: 'Een weekend voor twee op Valentijnsdag',
  },
  saintValentinText: {
    id: `${giftCardScope}.saintValentinText`,
    defaultMessage:
      "Une carte cadeau pour partir en amoureux, en train ou en bus. Vous choisissez le montant, l'autre choisit la destination.",
    en: 'A gift card to go away together, by train or bus. You choose the amount, they choose the destination.',
    es: 'Una tarjeta regalo para escaparse en pareja, en tren o en autobús. Usted elige el importe, la otra persona el destino.',
    it: "Una carta regalo per partire in coppia, in treno o in autobus. Lei sceglie l'importo, l'altra persona la meta.",
    de: 'Eine Geschenkkarte für eine Reise zu zweit, mit Zug oder Bus. Sie wählen den Betrag, der andere das Ziel.',
    nl: 'Een cadeaukaart om samen weg te gaan, met de trein of de bus. U kiest het bedrag, de ander de bestemming.',
  },
  feteDesMeresTitle: {
    id: `${giftCardScope}.feteDesMeresTitle`,
    defaultMessage: 'Pour la fête des mères, offrez un voyage',
    en: "For Mother's Day, give a trip",
    es: 'Para el Día de la Madre, regale un viaje',
    it: 'Per la festa della mamma, regala un viaggio',
    de: 'Zum Muttertag eine Reise verschenken',
    nl: 'Geef voor Moederdag een reis cadeau',
  },
  feteDesMeresText: {
    id: `${giftCardScope}.feteDesMeresText`,
    defaultMessage:
      'Un séjour au bord de la mer ou une visite à la famille : elle choisit son trajet, vous offrez le voyage.',
    en: 'A stay by the sea or a visit to family: she chooses her trip, you give the journey.',
    es: 'Una estancia junto al mar o una visita a la familia: ella elige su trayecto, usted regala el viaje.',
    it: 'Un soggiorno al mare o una visita alla famiglia: lei sceglie il tragitto, voi regalate il viaggio.',
    de: 'Ein Aufenthalt am Meer oder ein Besuch bei der Familie: Sie wählt die Strecke, Sie schenken die Reise.',
    nl: 'Een verblijf aan zee of een bezoek aan familie: zij kiest haar traject, u geeft de reis.',
  },
  feteDesPeresTitle: {
    id: `${giftCardScope}.feteDesPeresTitle`,
    defaultMessage: 'Pour la fête des pères, offrez un voyage',
    en: "For Father's Day, give a trip",
    es: 'Para el Día del Padre, regale un viaje',
    it: 'Per la festa del papà, regala un viaggio',
    de: 'Zum Vatertag eine Reise verschenken',
    nl: 'Geef voor Vaderdag een reis cadeau',
  },
  feteDesPeresText: {
    id: `${giftCardScope}.feteDesPeresText`,
    defaultMessage:
      "Un bol d'air en montagne ou un week-end en ville : il choisit son trajet, vous offrez le voyage.",
    en: 'Fresh air in the mountains or a weekend in town: he chooses his trip, you give the journey.',
    es: 'Aire puro en la montaña o un fin de semana en la ciudad: él elige su trayecto, usted regala el viaje.',
    it: 'Aria pura in montagna o un weekend in città: lui sceglie il tragitto, voi regalate il viaggio.',
    de: 'Frische Luft in den Bergen oder ein Wochenende in der Stadt: Er wählt die Strecke, Sie schenken die Reise.',
    nl: 'Frisse lucht in de bergen of een weekend in de stad: hij kiest zijn traject, u geeft de reis.',
  },
  mariageTitle: {
    id: `${giftCardScope}.mariageTitle`,
    defaultMessage: 'Un voyage de noces en cadeau',
    en: 'A honeymoon as a gift',
    es: 'Un viaje de novios de regalo',
    it: 'Un viaggio di nozze in regalo',
    de: 'Eine Hochzeitsreise als Geschenk',
    nl: 'Een huwelijksreis cadeau',
  },
  mariageText: {
    id: `${giftCardScope}.mariageText`,
    defaultMessage:
      'Participez au voyage de noces, en train ou en bus, partout en France et en Europe. Chaque invité peut offrir sa carte : les mariés les cumulent.',
    en: 'Chip in for the honeymoon, by train or bus, anywhere in France and Europe. Each guest can give a card: the couple can combine them.',
    es: 'Contribuya al viaje de novios, en tren o autobús, por Francia y Europa. Cada invitado puede regalar su tarjeta: los novios las combinan.',
    it: 'Contribuisca al viaggio di nozze, in treno o in autobus, in Francia e in Europa. Ogni invitato può regalare la sua carta: gli sposi le cumulano.',
    de: 'Beteiligen Sie sich an der Hochzeitsreise, mit Zug oder Bus, in Frankreich und Europa. Jeder Gast kann eine Karte schenken: Das Paar kann sie kombinieren.',
    nl: 'Draag bij aan de huwelijksreis, met de trein of de bus, in heel Frankrijk en Europa. Elke gast kan een kaart geven: het paar kan ze combineren.',
  },
  retraiteTitle: {
    id: `${giftCardScope}.retraiteTitle`,
    defaultMessage: 'Pour un départ à la retraite, offrez des voyages',
    en: 'For a retirement, give trips',
    es: 'Para una jubilación, regale viajes',
    it: 'Per un pensionamento, regala dei viaggi',
    de: 'Zum Ruhestand Reisen verschenken',
    nl: 'Geef reizen cadeau bij een pensioen',
  },
  retraiteText: {
    id: `${giftCardScope}.retraiteText`,
    defaultMessage:
      'Le temps est enfin là : offrez les trajets qui vont avec. Une carte valable 1 an, utilisable en plusieurs fois.',
    en: 'Time has finally come: give the trips to go with it. A card valid 1 year, usable several times.',
    es: 'Por fin hay tiempo: regale los trayectos que lo acompañan. Una tarjeta válida 1 año, utilizable varias veces.',
    it: "Finalmente c'è tempo: regali i viaggi che lo accompagnano. Una carta valida 1 anno, utilizzabile più volte.",
    de: 'Endlich ist Zeit da: Schenken Sie die passenden Reisen dazu. Eine Karte, 1 Jahr gültig, mehrfach nutzbar.',
    nl: 'Eindelijk is er tijd: geef de reizen die erbij horen. Een kaart, 1 jaar geldig, meerdere keren te gebruiken.',
  },
  promoLink: {
    id: `${giftCardScope}.promoLink`,
    defaultMessage: 'Vous avez un code promo ou une carte cadeau ?',
    en: 'Do you have a promo code or a gift card?',
    es: '¿Tienes un código promocional o una tarjeta regalo?',
    it: 'Hai un codice promozionale o una carta regalo?',
    de: 'Haben Sie einen Gutscheincode oder eine Geschenkkarte?',
    nl: 'Heeft u een promotiecode of een cadeaukaart?',
  },
  promoLinkMore: {
    id: `${giftCardScope}.promoLinkMore`,
    defaultMessage: 'Ajouter une carte cadeau',
    en: 'Add a gift card',
    es: 'Añadir una tarjeta regalo',
    it: 'Aggiungi una carta regalo',
    de: 'Geschenkkarte hinzufügen',
    nl: 'Cadeaukaart toevoegen',
  },
  emailCheckPending: {
    id: `${giftCardScope}.emailCheckPending`,
    defaultMessage: 'à confirmer',
    en: 'to confirm',
    es: 'por confirmar',
    it: 'da confermare',
    de: 'zu bestätigen',
    nl: 'te bevestigen',
  },
};
